'use client';

import { c as _c } from "react/compiler-runtime";
import { hasVisitedAiProficiencyPage, markAiProficiencyPageVisited } from '@/domains/pages/ai-proficiency/utils/page-session';
import { useLayoutEffect } from 'react';

/** Skip full-page skeleton when revisiting a page that already loaded in this session. */
export function useAiProficiencyShellLoading(pageKey, isInitialLoading, isError) {
  const $ = _c(8);
  let t0;
  if ($[0] !== isInitialLoading || $[1] !== pageKey) {
    t0 = isInitialLoading && !hasVisitedAiProficiencyPage(pageKey);
    $[0] = isInitialLoading;
    $[1] = pageKey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const showPageShellLoading = t0;
  let t1;
  let t2;
  if ($[3] !== isError || $[4] !== isInitialLoading || $[5] !== pageKey) {
    t1 = () => {
      if (!isInitialLoading && !isError) {
        markAiProficiencyPageVisited(pageKey);
      }
    };
    t2 = [isError, isInitialLoading, pageKey];
    $[3] = isError;
    $[4] = isInitialLoading;
    $[5] = pageKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useLayoutEffect(t1, t2);
  return showPageShellLoading;
}